<div fxFlex fxLayout="row">
  <div fxFlex="90" fxLayout="column" fxLayoutAlign="center start">
    <div class="date">{{ notification.time | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
    <div>{{ (notificationService.getNotificationText(notification) | async) || ('noDetails' | translate) }}</div>
    <div *ngIf="notification.url" class="mt-2">
      <ng-container *ngIf="isInternalUrl(notification.url); then internalRouting else externalRouting"></ng-container>
      <ng-template #internalRouting>
        <button mat-raised-button [routerLink]="notification.url">{{ 'goTo' | translate }}</button>
      </ng-template>
      <ng-template #externalRouting>
        <a mat-raised-button [href]="notification.url" target="_blank">{{ 'goTo' | translate }}</a>
      </ng-template>
    </div>
  </div>
  <div fxFlex="10" fxLayoutAlign="center center" (click)="deleteNotification.next(notification);">
    <mat-icon matTooltip="{{ 'deleteNotification' | translate }}" svgIcon="delete"></mat-icon>
  </div>
</div>